const APP_PREPEND = "api";

// prepends

const WIDGETS_PREPEND = "widget";
const APPS_PREPEND = "app";
const BUTTONS_PREPEND = "button";
const STUDENT_HELP_PREPEND = "studentHelp";
const STUDENT_RESOURCE_PREPEND = "studentResource";
const NOTIFICATION_PREPEND = "notification";
const TECHNOLOGY_RESOURCE_BLOCK_PREPEND = "technologyResourceBlock";
const MEDIA_CONTENT_PREPEND = "mediaContentBlock";
const COMMON_PREPEND = "common";
const DEPARTMENT_PREPEND = "department";
const DEPARTMENT_RESOURCE_PREPEND = "departmentResourceBlock";
const COLLEGE_PREPEND = "college";
const SNAPSHOT_PREPEND = "pageBlock";
const REPORT_PREPEND = "reportBlock";
const TRAINING_BLOCK_PREPEND = "trainingBlock";
const TRAINING_HELP_PREPEND = "trainingHelpVideo";
const STUDENT_DETAILS = "studentDetails";
const TASK_PREPEND = "task";
const STAFF_PREPEND = "staffDetails"
const STAFF_DETAIL_PREPEND = "staffDetails";
const FACULTY_PREPEND = "facultyDetails";
const USER_PREPEND = "user";
const STUDENT_COURSE_RATE = "studentCourseRate";
const STUDENT_FEEDBACK_RATE = "StudentFeedbackRate";
const FEEDBACK_DETAILS_PREPEND = 'Email';
const COMMON_DETAILS_PREPEND = "CommonDetail";
const EMAIL_CONFIGURATION_PREPEND = "EmailConfiguration"
const DESCRIPTION_PREPEND = "Description";
const ADMIN_PREPEND = "Admin";
const CHATBOT_PREPEND = "AI";
const FRESHMAN_MAINSTEP_PREPEND = "freshmanmainstep"
const SUBSTEP_PREPEND = "freshmanSubStep";
const FRESHMAN_PROCESS_PREPEND = "FreshmanRegistration"
const FRESHMAN_CONFIGURATION_PREPEND = "FreshmanStepConfiguration";
const AI_CONFIGURATION_PREPEND = "AIAgentConfiguration"

//Common
export const common = {
  GET_ADMIN_APPROVAL: "FreshmanRegistration/approval?token={token}",
  UPDATE_PRIORITY: COMMON_PREPEND + "/userPriority",
  GET_PAGEBLOCKS: COMMON_PREPEND + "/pageBlocks",
  GET_USERTYPES: COMMON_PREPEND + "/userTypes",
  GET_COLLEGETYPES: COMMON_PREPEND + "/getAllCollegeTypes",
  GET_DEPARTMENTS: DEPARTMENT_PREPEND + "/keyValuePairs?collegeId={collegeId}",
  GET_COLLEGES: COLLEGE_PREPEND + "/keyValuePairs",
  GET_UNIVERSITIES: COMMON_PREPEND + "/universities",
  GET_NOTIFICATION_TYPES: NOTIFICATION_PREPEND + "/KeyValuePairs",
  GET_USER_PAGEBLOCKS: COMMON_PREPEND + "/userPageBlocks?userType={userType}&type={type}",
  GET_COLLEGE_DEPARTMENTS: COMMON_PREPEND + "/getAllCollegeDepartments?collegeIds={collegeIds}",
  GET_TAST_RESPECTS: TASK_PREPEND + "/getAllTaskRespect",
  GET_TASK_STATUS: TASK_PREPEND + "/getAllTaskCurrentStatus",
  GET_REPORT_FREQUENCY: COMMON_PREPEND + "/getAllReportFrequency",
  GET_REPORT_NAME_WITH_DESCRIPTION: REPORT_PREPEND + "/getAllReportInformation",
  GET_TRAINING_CATEGORY: COMMON_PREPEND + "/getAllTrainingCategory",
  CREATE_PORTAL_RATING: COMMON_PREPEND + "/createPortalRating",
  GET_PORTAL_RATING: COMMON_PREPEND + "/getAllPortalRating",
  GET_TRAINING_NAME_WITH_DESCRIPTION_AND_DATE: TRAINING_BLOCK_PREPEND + "/getAllTrainingInformation",
  GET_SAFETY_ALERT_CAMPUS: STUDENT_DETAILS + "/campusSafetyAlerts",
  GET_DEPARTMENMT_NAME: COMMON_DETAILS_PREPEND + "/getDepartmentName?college={college}",
  GET_COLLEGE_NAME: COMMON_DETAILS_PREPEND + "/collegeDetails?type={type}",
  CREATE_FEEDBACK_DETAILS: FEEDBACK_DETAILS_PREPEND + "/sendEmail",
  GET_TO_MAIL_ID: EMAIL_CONFIGURATION_PREPEND + "/toEmailId?emailBlockId={emailBlockId}",
  GET_DESCRIPTION_TEXT: DESCRIPTION_PREPEND + "/descriptionByPageBlock?pageBlockId={pageBlockId}",
  SEND_CHATBOT_MESSAGE: CHATBOT_PREPEND + "/chatRAG",
  SEND_STUDENT_MESSAGE: CHATBOT_PREPEND + "/GENERAL_CALL_AI",
  FACULTY_GRADING_AND_FEEDBACK_AGENT: CHATBOT_PREPEND + "/GradingAndFeedbackSupportAgent",
  SUPER_AGENT: CHATBOT_PREPEND + "/SuperAgent",
  GET_SUBSTEPS: SUBSTEP_PREPEND + "/keyValuePairs",
  GET_STUDENT_TYPE: COMMON_PREPEND + "/getAllStudentType",
  AI_CHAT_MESSAGE: CHATBOT_PREPEND + "/Super_Agent",
  GET_AI_AGENTS: COMMON_PREPEND + "/aiAgents?userType={userType}",
  GET_USERSUBROLES: COMMON_PREPEND + "/subRoles",
};

export const keyCloakConstants = {
  TOKEN: '/realms/budu/protocol/openid-connect/token',
  GET_ROLE_USERS: '/admin/realms/budu/roles/{role}/users'
}

export const calendarConstants = {
  GET_GRAPH_API_TOKEN: `auth/GetGraphApiAccessToken`,
  GET_OUTLOOK_CALENDAR_EVENTS: `Calender/getOutlookCalenderEvents?startDateTime={startDateTime}&endDateTime={endDateTime}&userEmail={userEmail}`,
  GET_GOOGLE_CALENDAR_EVENTS: `Calender/getGoogleCalenderEvents?startDateTime={startDateTime}&endDateTime={endDateTime}&userEmail={userEmail}`,
}

//masters

export const widgets = {
  GET_ALL_WIDGETS:
    WIDGETS_PREPEND +
    "/getAllWidgets?configUserType={configUserType}&PageBlock={pageBlockId}&collegeId={collegeId}&pageSize={noOfItems}",
  CREATE_WIDGET: WIDGETS_PREPEND,
  UPDATE_WIDGET: WIDGETS_PREPEND + "/{id}",
  GET_WIDGET: WIDGETS_PREPEND + "/{id}",
  DELETE_WIDGET: WIDGETS_PREPEND + "/{id}",
  UPDATE_WIDGET_PRIORITY: WIDGETS_PREPEND + "/updateWidgetPriority",
};

export const apps = {
  GET_ALL_APPS:
    APPS_PREPEND +
    "/getAllApps?configUserType={configUserType}&PageBlock={pageBlockId}&collegeId={collegeId}&pageSize={noOfItems}",
  CREATE_APP: APPS_PREPEND,
  UPDATE_APP: APPS_PREPEND + "/{id}",
  GET_APP: APPS_PREPEND + "/{id}",
  DELETE_APP: APPS_PREPEND + "/{id}",
  UPDATE_APP_PRIORITY: APPS_PREPEND + "/updateAppPriority",
};

export const emailConfiguration = {
  GET_ALL_EMAIL_CONFIGURATIONS: EMAIL_CONFIGURATION_PREPEND + "/getAllEmailConfigurations?collegeId={collegeId}",
  CREATE_EMAIL_CONFIGURATION: EMAIL_CONFIGURATION_PREPEND,
  UPDATE_EMAIL_CONFIGURATION: EMAIL_CONFIGURATION_PREPEND + "/{id}",
  GET_EMAIL_CONFIGURATION: EMAIL_CONFIGURATION_PREPEND + "?id={id}",
  DELETE_EMAIL_CONFIGURATION: EMAIL_CONFIGURATION_PREPEND + "/{id}",
  GET_EMAIL_BLOCK_USERTYPES: EMAIL_CONFIGURATION_PREPEND + "/user-types?emailBlockId={emailBlockId}",
  GET_EMAIL_BLOCK: EMAIL_CONFIGURATION_PREPEND + "/emailBlocks"
};

export const buttons = {
  GET_ALL_BUTTONS:
    BUTTONS_PREPEND + "/getAllButtons?configUserType={configUserType}&PageBlock={pageBlockId}&collegeId={collegeId}&pageSize={noOfItems}",
  CREATE_BUTTON: BUTTONS_PREPEND,
  UPDATE_BUTTON: BUTTONS_PREPEND + "/{id}",
  GET_BUTTON: BUTTONS_PREPEND + "/{id}",
  DELETE_BUTTON: BUTTONS_PREPEND + "/{id}",
  UPDATE_BUTTON_PRIORITY: BUTTONS_PREPEND + "/updateButtonPriority",
};

export const description = {
  GET_ALL_DESCRIPTIONS: DESCRIPTION_PREPEND + "/getAllDescription?configUserType={configUserType}",
  CREATE_DESCRIPTION: DESCRIPTION_PREPEND,
  UPDATE_DESCRIPTION: DESCRIPTION_PREPEND + "/{id}",
  GET_DESCRIPTION: DESCRIPTION_PREPEND + "/{id}",
  DELETE_DESCRIPTION: DESCRIPTION_PREPEND + "/{id}",
};

export const studentHelps = {
  GET_ALL_STUDENT_HELPS:
    STUDENT_HELP_PREPEND +
    "/getAllStudentHelps?configUserType={configUserType}",
  CREATE_STUDENT_HELP: STUDENT_HELP_PREPEND,
  UPDATE_STUDENT_HELP: STUDENT_HELP_PREPEND + "/{id}",
  GET_STUDENT_HELP: STUDENT_HELP_PREPEND + "/{id}",
  DELETE_STUDENT_HELP: STUDENT_HELP_PREPEND + "/{id}",
  UPDATE_STUDENT_HELP_PRIORITY:
    STUDENT_HELP_PREPEND + "/updateStudentHelpPriority",
};

export const studentResources = {
  GET_ALL_STUDENT_RESOURCES:
    STUDENT_RESOURCE_PREPEND +
    "/getAllStudentResources?configUserType={configUserType}",
  CREATE_STUDENT_RESOURCE: STUDENT_RESOURCE_PREPEND,
  UPDATE_STUDENT_RESOURCE: STUDENT_RESOURCE_PREPEND + "/{id}",
  GET_STUDENT_RESOURCE: STUDENT_RESOURCE_PREPEND + "/{id}",
  DELETE_STUDENT_RESOURCE: STUDENT_RESOURCE_PREPEND + "/{id}",
  UPDATE_STUDENT_RESOURCE_PRIORITY:
    STUDENT_RESOURCE_PREPEND + "/updateStudentResourcePriority",
};

export const studentEvents = {
  GET_EVENT_DETAILS: STUDENT_DETAILS + "/StudentEvent?selectedDate={selectedDate}",
}

export const notifications = {
  GET_ALL_NOTIFICATIONS:
    NOTIFICATION_PREPEND +
  "/getAllNotifications?configUserType={configUserType}&pageBlock={pageBlock}&departmentId={departmentId}&collegeId={collegeId}&pageSize={noOfItems}&notificationTypeId={notificationTypeId}&pageNumber={pageNumber}",
  CREATE_NOTIFICATION: NOTIFICATION_PREPEND,
  UPDATE_NOTIFICATION: NOTIFICATION_PREPEND + "/{id}",
  GET_NOTIFICATION: NOTIFICATION_PREPEND + "/{id}",
  DELETE_NOTIFICATION: NOTIFICATION_PREPEND + "/{id}",
  UPDATE_NOTIFICATION_PRIORITY:
    NOTIFICATION_PREPEND + "/updateNotificationPriority",
  UPDATE_NOTIFICATION_STATUS: NOTIFICATION_PREPEND + "/updateUserNotificationstatus",
  GET_NOTIFICATION_TYPE: NOTIFICATION_PREPEND + "/keyValuePairs",
  GET_NOTIFICATION_COUNT: NOTIFICATION_PREPEND + "/getNotificationCount?configUserType={configUserType}&notificationTypeId={notificationTypeId}",
};

export const departments = {
  GET_ALL_DEPARTMENTS: DEPARTMENT_PREPEND + "/getAllDepartments",
  CREATE_DEPARTMENT: DEPARTMENT_PREPEND,
  UPDATE_DEPARTMENT: DEPARTMENT_PREPEND + "/{id}",
  GET_DEPARTMENT: DEPARTMENT_PREPEND + "/{id}",
  DELETE_DEPARTMENT: DEPARTMENT_PREPEND + "/{id}",
  GET_DEPARTMENT_WITH_ID: DEPARTMENT_PREPEND + "?id={id}",
  GET_DEPARTMENT_WITHOUT_ID: DEPARTMENT_PREPEND,
  GET_DEPARTMENT_MAIL_ID: DEPARTMENT_PREPEND + "/emailId",
};

export const colleges = {
  GET_ALL_COLLEGES: COLLEGE_PREPEND + "/getAllcolleges",
  CREATE_COLLEGE: COLLEGE_PREPEND,
  UPDATE_COLLEGE: COLLEGE_PREPEND + "/{id}",
  DELETE_COLLEGE: COLLEGE_PREPEND + "/{id}",
  GET_COLLEGE_WITH_ID: COLLEGE_PREPEND + "?id={id}",
  GET_COLLEGE_WITHOUT_ID: COLLEGE_PREPEND,
};

export const snapShots = {
  GET_ALL_SNAPSHOTS:
    SNAPSHOT_PREPEND + "/getAllPageBlocks?configUserType={configUserType}",
  GET_SNAPSHOT: SNAPSHOT_PREPEND + "/{id}",
  UPDATE_SNAPSHOT: SNAPSHOT_PREPEND + "/{id}",
  UPDATE_SNAPSHOT_PRIORITY: SNAPSHOT_PREPEND + "/updatePageBlockVisibility",
};

export const technologyResources = {
  GET_ALL_TECHNOLOGY_RESOURCE_BLOCKS:
    TECHNOLOGY_RESOURCE_BLOCK_PREPEND +
    "/getAllTechnologyResourceBlocks?configUserType={configUserType}&pageBlock={pageBlockId}&collegeId={collegeId}&departmentId={departmentId}&pageSize={noOfItems}",
  CREATE_TECHNOLOGY_RESOURCE_BLOCK: TECHNOLOGY_RESOURCE_BLOCK_PREPEND,
  UPDATE_TECHNOLOGY_RESOURCE_BLOCK: TECHNOLOGY_RESOURCE_BLOCK_PREPEND + "/{id}",
  GET_TECHNOLOGY_RESOURCE_BLOCK: TECHNOLOGY_RESOURCE_BLOCK_PREPEND + "/{id}",
  DELETE_TECHNOLOGY_RESOURCE_BLOCK: TECHNOLOGY_RESOURCE_BLOCK_PREPEND + "/{id}",
  UPDATE_TECHNOLOGY_RESOURCE_BLOCK_PRIORITY:
    TECHNOLOGY_RESOURCE_BLOCK_PREPEND + "/updateTechnologyResourcePriority",
};

export const mediaContents = {
  GET_ALL_MEDIA_CONTENTS:
    MEDIA_CONTENT_PREPEND +
    "/getAllMediaContentBlock?configUserType={configUserType}",
  CREATE_MEDIA_CONTENT: MEDIA_CONTENT_PREPEND,
  UPDATE_MEDIA_CONTENT: MEDIA_CONTENT_PREPEND + "/{id}",
  GET_MEDIA_CONTENT: MEDIA_CONTENT_PREPEND + "/{id}",
  DELETE_MEDIA_CONTENT: MEDIA_CONTENT_PREPEND + "/{id}",
  UPDATE_MEDIA_CONTENT_PRIORITY:
    MEDIA_CONTENT_PREPEND + "/updateMediaContentBlockPriority",
};

export const departmentResources = {
  GET_ALL_DEPARTMENT_RESOURCES:
    DEPARTMENT_RESOURCE_PREPEND +
    "/getAllDepartmentResourceBlocks?PageBlock={PageBlock}&pageSize={noOfItems}&configUserType={configUserType}",
  CREATE_DEPARTMENT_RESOURCE: DEPARTMENT_RESOURCE_PREPEND,
  UPDATE_DEPARTMENT_RESOURCE: DEPARTMENT_RESOURCE_PREPEND + "/{id}",
  GET_DEPARTMENT_RESOURCE: DEPARTMENT_RESOURCE_PREPEND + "/{id}",
  DELETE_DEPARTMENT_RESOURCE: DEPARTMENT_RESOURCE_PREPEND + "/{id}",
  UPDATE_DEPARTMENT_RESOURCE_PRIORITY:
    DEPARTMENT_RESOURCE_PREPEND + "/updateDepartmentResourceBlockPriority",
};

export const reports = {
  GET_ALL_REPORTS:
    REPORT_PREPEND + "/getAllreportBlocks?configUserType={configUserType}&pageBlock={pageBlockId}&pageSize={noOfItems}&reportFrequency={reportFrequency}",
  CREATE_REPORT: REPORT_PREPEND,
  UPDATE_REPORT: REPORT_PREPEND + "/{id}",
  GET_REPORT: REPORT_PREPEND + "/{id}",
  DELETE_REPORT: REPORT_PREPEND + "/{id}",
  UPDATE_REPORT_PRIORITY: REPORT_PREPEND + "/reportBlockPriority",
};

export const trainings = {
  GET_ALL_TRAINING_BLOCKS: TRAINING_BLOCK_PREPEND +
    "/getAllTrainingBlocks?pageBlock={pageBlockId}&pageSize={noOfItems}&configUserType={configUserType}",
  CREATE_TRAINING_BLOCK: TRAINING_BLOCK_PREPEND,
  UPDATE_TRAINING_BLOCK: TRAINING_BLOCK_PREPEND + "/{id}",
  GET_TRAINING_BLOCK: TRAINING_BLOCK_PREPEND + "/{id}",
  DELETE_TRAINING_BLOCK: TRAINING_BLOCK_PREPEND + "/{id}",
  UPDATE_TRAINING_BLOCK_PRIORITY: TRAINING_BLOCK_PREPEND + "/trainingBlockPriority",
};

export const trainingHelps = {
  GET_ALL_TRAINING_HELPS:
    TRAINING_HELP_PREPEND +
    "/getAllTrainingHelpVideos?pageBlock={pageBlock}&pageSize={noOfItems}&configUserType={configUserType}",
  CREATE_TRAINING_HELP: TRAINING_HELP_PREPEND,
  UPDATE_TRAINING_HELP: TRAINING_HELP_PREPEND + "/{id}",
  GET_TRAINING_HELP: TRAINING_HELP_PREPEND + "/{id}",
  DELETE_TRAINING_HELP: TRAINING_HELP_PREPEND + "/{id}",
  UPDATE_TRAINING_HELP_PRIORITY:
    TRAINING_HELP_PREPEND + "/updateTrainingHelpPriority",
};

export const academicProfile = {
  UPDATE_ACADEMIC_DETAILS: TRAINING_HELP_PREPEND + "/{id}",
  GET_ACADEMIC_DETAILS: STUDENT_DETAILS + "/overallAcademicDetail/{id}",
};

export const tasks = {
  GET_ALL_TASKS:
    TASK_PREPEND +
    "/getAllTasks?noOfItems={noOfItems}",
  CREATE_TASK: TASK_PREPEND,
  UPDATE_TASK: TASK_PREPEND + "/{id}",
  GET_TASK: TASK_PREPEND + "/{id}",
  DELETE_TASK: TASK_PREPEND + "/{id}",
  GET_WORKLOAD: TASK_PREPEND + "/getWorkload"
};

export const student = {
  STUDENT_COURCE_DETAIL: STUDENT_DETAILS + "/studentCourceSemesterInfo/{semesterId}",
  STUDENT_ACCOUNT_DETAIL: STUDENT_DETAILS + "/studentAccountDetails",
  STUDENT_GRADE_DETAIL: STUDENT_DETAILS + "/studentCourseGradeDistribution/{studentId}",
  STUDENT_INFO: STUDENT_DETAILS + "/academicDetails/{id}",
  STUDENT_TRASACTION_DETAILS: STUDENT_DETAILS + "/studentTransactions/{noOfItems}",
  STUDENT_FINANCIAL_ACCOUNT_DETAILS: STUDENT_DETAILS + "/studentFinanceAccount/{studentId}",
  STUDENT_EARLY_ALERTS: STUDENT_DETAILS + "/earlyAlerts/{id}/{count}",
  STUDENT_GRADE: STUDENT_DETAILS + "/studentGradeWithMark/{currentTermId}/{studentId}",
  STUDENT_CURRENT_OPENING_DETAILS: "onet/careers?pageNumber={pageNumber}&keyword={keyword}",
  STUDENT_CURRENT_OPENING_DESCRIPTION: "onet/description?jobCode={jobCode}",
  STUDENT_RATE_COURSE: STUDENT_COURSE_RATE,
  STUDENT_RATE_COURSE_DETAILS: STUDENT_COURSE_RATE + "/{courseId}",
  STUDENT_RATE_FEEDBACK: STUDENT_FEEDBACK_RATE,
  STUDENT_TERM: STUDENT_DETAILS + "/studentTerm",
  STUDENT_FACULTY_HELP_MAIL: STUDENT_DETAILS + "/facultyContactMail",
  STUDENT_ADVISOR_HELP_MAIL: STUDENT_DETAILS + "/advisorContactMail",
  STUDENT_ALL_CONTACT_MAIL: STUDENT_DETAILS + "/allContactMail"
}

export const staffConnect = {
  GET_ALL_STAFF_CONNECT_WITH_DEPARTMENT:
    STAFF_PREPEND +
    "/staffCommunicationDetails?departmentId={departmentId}",
  GET_ALL_STAFF_CONNECT_WITHOUT_DEPARTMENT:
    STAFF_PREPEND +
    "/staffCommunicationDetails",
}
export const StaffTrainingRegisterAndAttend = {
  GET_STAFF_TRAINING_REGISTER_AND_ATTEND: STAFF_PREPEND + "/staffTrainingBlockRegisterAndAttend?trainingBlockId={trainingBlockId}"
}
export const staffTraining = {
  TRAINING_COMPLETION_DETAILS: STAFF_DETAIL_PREPEND + "/stafTrainingComplition",
};
export const faculty = {
  GET_FACULTY_CONNECT: FACULTY_PREPEND + "/studentcommunicationdetails/{id}",
  GET_FACULTY_CONNECT_CLASS: FACULTY_PREPEND + "/facultyclassdetails"
}

export const user = {
  GET_USER_PROFILE_DATA: USER_PREPEND + "/currentUserData",
  UPDATE_USER_PROFILE_DATA: USER_PREPEND,
  UPDATE_USER_PROFILE: USER_PREPEND + "/userProfile",
  LOGIN_USER: USER_PREPEND + "/loginUser?username={username}&password={password}",
}

export const freshmanMainStep = {
  INACTIVE_MAIN_STEP: FRESHMAN_MAINSTEP_PREPEND + "/{id}",
  GET_MAINSTEP: FRESHMAN_MAINSTEP_PREPEND + "/{id}",
  UPDATE_MAINSTEP: FRESHMAN_MAINSTEP_PREPEND + "/{id}",
  GET_ALL_MAINSTEP: FRESHMAN_MAINSTEP_PREPEND + "/?includeInactive={includeInactive}",
  CREATE_MAINSTEP: FRESHMAN_MAINSTEP_PREPEND,
  KEY_VALUE_PAIR: FRESHMAN_MAINSTEP_PREPEND + "/keyvaluepairs"
}

export const subStep = {
  GET_SUBSTEP: SUBSTEP_PREPEND + "/{id}",
  GET_ALL_SUBSTEP: SUBSTEP_PREPEND + "/getAllSubSteps?includeInactive={includeInactive}",
  CREATE_SUBSTEP: SUBSTEP_PREPEND,
  UPDATE_SUBSTEP: SUBSTEP_PREPEND + "/{id}",
  INACTIVATE_SUBSTEP: SUBSTEP_PREPEND + "/{id}",
  KEY_VALUE_PAIR: SUBSTEP_PREPEND + "/keyvaluepairs"

}

export const freshmanProcess = {
  GET_ALL_MAINSTEP_PERCENTAGE: FRESHMAN_PROCESS_PREPEND + "/getAllMainStepPercentage",
  GET_SUBSTEP_BY_MAINSTEP_ID: FRESHMAN_PROCESS_PREPEND + "/getAllSubStep/{id}",
  UPDATE_FRESHMAN_SUBSTEP_PERCENTAGE: FRESHMAN_PROCESS_PREPEND + "/updateFreshmanSubStepPercentageDetail",
  GET_FRSHMAN_PROCESS_VERSION: FRESHMAN_PROCESS_PREPEND + "/getFreshmanProcessVersion"
}


export const freshman_configuration = {
  CREATE_FRESHMAN_CONFIGURATION: FRESHMAN_CONFIGURATION_PREPEND,
  GET_FRESHMAN_CONIFIGURATION: FRESHMAN_CONFIGURATION_PREPEND + "/{studentCategoryId}",
  GET_ALL_FRESHMAN_CONFIGURATION: FRESHMAN_CONFIGURATION_PREPEND + "/getAllFreshmanStepConfigurations",
  UPDATE_FRESHMAN_CONFIGURATION: FRESHMAN_CONFIGURATION_PREPEND + "/{studentCategoryId}",
  INACTIVATE_FRESHMAN_CONFIGURATION: FRESHMAN_CONFIGURATION_PREPEND + "/{studentCategoryId}",
  GET_ALL_VERSION: FRESHMAN_CONFIGURATION_PREPEND + "/GetAllVersions?studentCategoryId={studentCategoryId}",
  GET_ALL_INACTIVE_VERSION: FRESHMAN_CONFIGURATION_PREPEND + "/getAllInactiveVersionConfigurations?studentCategoryId={studentCategoryId}&versionId={versionId}"
}

export const aiConfiguration ={
  GET_ALL_API_KEY_CONFIGURATION: AI_CONFIGURATION_PREPEND + "/getAllApiKeyAgentConfiguration?collegeId={collegeId}",
  GET_API_KEY_CONFIGURATION: AI_CONFIGURATION_PREPEND + "/apiKey/{id}",
  CREATE_API_KEY_CONFIGURATION: AI_CONFIGURATION_PREPEND + "/createApiKeyConfiguration",
  UPDATE_API_KEY_CONFIGURATION: AI_CONFIGURATION_PREPEND + "/apiKey/{id}",
  DELETE_API_KEY_CONFIGURATION: AI_CONFIGURATION_PREPEND + "/apiKey/{id}",
}

export const aiChatBot = {
    GET_PREVIOUS_CHAT_MESSAGES: CHATBOT_PREPEND + "/chatHistory?limit={limit}",
    UPDATE_AI_CHAT_SESSIONS: CHATBOT_PREPEND + "/updateAISession",
    GET_AI_AGENT_KEY: CHATBOT_PREPEND + "/getAiAgentKey",
    GET_SESSION_MESSAGES: CHATBOT_PREPEND + "/sessionMessages",
    GET_SESSION_DETAIL: CHATBOT_PREPEND + "/sessionDetail",
}